import type { Page } from '../../types';

const civilAction: Page[] = [
  {
    pageType: 'question',
    title: 'Civil action',
    name: 'civil-action-declare',
    questions: [
      {
        questionType: 'radio',
        title: 'Do you have any instances of civil action to declare?',
        name: 'benefits_poca_civil_declare',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
    ],
  },
  {
    pageType: 'question',
    title: 'Civil action',
    name: 'civil-action',
    type: 'nilreturn',
    fastToggle: true,
    total: {
      columns: [
        { title: 'Number of instances', field: 'benefits_poca_civil_instances' },
        { title: 'Total Value', field: 'benefits_poca_civil' },
      ],
    },
    disabled: [
      {
        field: 'benefits_poca_civil_declare',
        condition: 'equals',
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'instanceInput',
        title: 'Total number of instances',
        name: 'benefits_poca_civil_instances',
        hint: '',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'costInput',
        displaySeperator: 'thousand',
        title: 'Estimated total value',
        name: 'benefits_poca_civil',
        hint: '',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'benefits_poca_civil_comments',
        hint: 'Please ensure you do not include any personal or sensitive information',
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default civilAction;




